import { TrendingUp, TrendingDown } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useCryptoPrice } from "@/hooks/useCryptoPrice";
import { Skeleton } from "@/components/ui/skeleton";

const LivePriceWidget = () => {
  const { data, isLoading, error } = useCryptoPrice('bitcoin');
  
  const btcPrice = data?.usd || 0;
  const change24h = data?.usd_24h_change || 0;
  const isPositive = change24h > 0;

  if (error) {
    return (
      <Card className="p-6 bg-card border-primary/20 glow-border min-h-[140px]">
        <p className="text-sm text-destructive">Failed to load price data</p>
      </Card>
    );
  }

  if (isLoading) {
    return (
      <Card className="p-6 bg-card border-primary/20 glow-border min-h-[140px]">
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-48" />
          <Skeleton className="h-3 w-20" />
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6 bg-card border-primary/20 glow-border min-h-[140px]">
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">Bitcoin Price</p>
        <div className="flex items-end gap-2">
          <h2 className="text-4xl font-bold glow-text animate-pulse">
            ${btcPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </h2>
          <div className={`flex items-center gap-1 pb-1 ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
            {isPositive ? <TrendingUp className="h-5 w-5" /> : <TrendingDown className="h-5 w-5" />}
            <span className="text-lg font-semibold">
              {isPositive ? '+' : ''}{change24h.toFixed(2)}%
            </span>
          </div>
        </div>
        <p className="text-xs text-muted-foreground">24h Change</p>
      </div>
    </Card>
  );
};

export default LivePriceWidget;
